import { SecureResponseFile } from './types';

export const convertToFormFile = (
  item: SecureResponseFile,
): { id: number; name: string } => ({
  id: item.id,
  name: `${item.name}.${item.extension}`,
});
